import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { ApiLocationsResponse } from '../lib/api/Locations';

import { useApi } from '../contexts/ApiContext';

type UseLocationsOptions = Omit<
    Parameters<
        typeof useQuery<
            ApiLocationsResponse,
            Error,
            ApiLocationsResponse,
            ['locations', Record<string, unknown> | null]
        >
    >[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useLocations(query = null, opts: UseLocationsOptions = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['locations', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.locations.get({ paginated: false, ...queryParam }, null, null, { signal }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    // const { data: items, pagination } = data || {};

    return {
        items: data,
        //   pagination,
        ...queryResult,
    };
}
